import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    ($setup.props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass({ required: $setup.props.required })
        }, _toDisplayString($setup.props.label), 3 /* TEXT, CLASS */))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["Multiselect"], {
      onChange: $setup.onInput,
      modelValue: $setup.data.valorInicial,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data.valorInicial) = $event)),
      mode: "single",
      disabled: $setup.props.disabled,
      caret: false,
      closeOnSelect: true,
      searchable: true,
      filterResults: false,
      minChars: 2,
      resolveOnLoad: false,
      required: $setup.props.required,
      object: true,
      delay: 300,
      placeholder: $setup.props.placeholder || 'Selecione uma das Opções',
      noOptionsText: "Digite para buscar",
      noResultsText: "Nenhuma opção encontrada",
      options: 
        async function (query) {
          return await $setup.props.fetchOptions(query);
        }
      
    }, null, 8 /* PROPS */, ["modelValue", "disabled", "required", "placeholder", "options"])
  ]))
}